import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { getUuidV4, handleNumberOnly, validarCPFCNPJ } from "../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ContratanteInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { Link } from "react-router-dom";
import { addContratante, removeContratante } from "../../../features/manifestoSlice";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";


const initialForm: ContratanteInterface = {
    id: 0,
    xNome: '',
    documento: '',
    idestrangeiro: false,
    infContrato: false,
    nroContrato: '',
    vContratoGlobal: 0
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function Contratante() {
    const dispatch = useDispatch();
    const listaContratantes = useSelector(
        (state: RootState) => state.manifesto.manifesto.modal_rodoviario?.infANTT.infContratante
    );
    const [form, setForm] = useState<ContratanteInterface>(initialForm)
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showModal, setShowModal] = useState<boolean>(false);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const validarPreenchimento = () => {
        if (form.documento === "") {
            alerta('Informe o CPF/CNPJ.');
            return false;
        }

        if (!form.idestrangeiro) {
            if (!validarCPFCNPJ(form.documento)) {
                alerta('CPF/CNPJ inválido.');
                return false;
            }
        }

        if (form.infContrato) {
            if (form.nroContrato === "" || form.nroContrato === "0") {
                alerta('Informe o número do contrato.');
                return false;
            }

            if (form.vContratoGlobal === 0) {
                alerta('Informe o valor do contrato.');
                return false;
            }

        }

        if (listaContratantes.find((item: ContratanteInterface) => item.documento === form.documento)) {
            alerta('Contratante com esse CPF/CNPJ já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addContratante({
                ...form,
                id: getUuidV4()
            }));
            setForm(initialForm);
        }

    }

    const handleRemover = (id: number | string) => {
        dispatch(removeContratante(id));
        setShowModal(false);
        setForm(initialForm);
        setSelected(initialSelect);
    }

    return (< >
        <Row className=" g-2 mb-3">
            <Col md={4} className="">
                <Form.Group className="" >
                    <Form.Label>Nome (opcional)</Form.Label>
                    <Form.Control placeholder="" name="xNome"
                        maxLength={30} type="text" onChange={handleChange} value={form.xNome} />
                </Form.Group>
            </Col>
            <Col md={2} className="">
                <Form.Group className="" >
                    <Form.Label>{!form.idestrangeiro ? 'CPF/CNPJ' : 'Identificador Contratante'}</Form.Label>
                    <Form.Control onKeyUp={handleNumberOnly} name="documento" value={form.documento}
                        maxLength={!form.idestrangeiro ? 14 : 20} type="text" onChange={handleChange} />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex  align-items-end">
                <Form.Group controlId="active">
                    <Form.Switch type="switch" checked={form.idestrangeiro} name="active" label="Estrangeiro?"
                        onChange={(e) => setForm({ ...form, idestrangeiro: e.target.checked })}
                    />
                </Form.Group>
            </Col>

            <Col md={'auto'} className="d-flex  align-items-end">

                <Form.Group className="">

                    <Button variant="primary" onClick={handleAdd}><FontAwesomeIcon icon={faPlus} />  Adicionar</Button>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={'auto'} className="d-flex align-items-center ">
                <Form.Group className="" controlId="active">
                    <Form.Switch className="" type="switch" onChange={(e) => {
                        setForm({
                            ...form,
                            nroContrato: !e.target.checked ? '' : form.nroContrato,
                            vContratoGlobal: !e.target.checked ? 0 : form.vContratoGlobal,
                            infContrato: e.target.checked

                        })
                    }}
                        checked={form.infContrato}
                        name="active" label="Indica dados do contrato?" />
                </Form.Group>
            </Col>
        </Row>

        <Row className="mb-3 g-2">
            {form.infContrato && (<>
                <Col md={2}>
                    <Form.Group>
                        <Form.Label>Nro. Contrato</Form.Label>
                        <Form.Control name="nroContrato" type="text" maxLength={20} placeholder=""
                            onKeyUp={handleNumberOnly} onChange={handleChange} />
                    </Form.Group>
                </Col>

                <Col md={2}>
                    <Form.Group>
                        <Form.Label>Vlr. Contrato Global</Form.Label>
                        <Form.Control type="number" value={form.vContratoGlobal} placeholder="" name="vContratoGlobal"
                            maxLength={15}
                            onChange={(e) => {
                                const { name, value } = e.target;

                                setForm({
                                    ...form,
                                    vContratoGlobal: parseFloat(
                                        value.replace(/[^0-9.]/g, "").replace(/(\.\d{2})\d+/, "$1")
                                    )
                                })
                            }}
                        />
                    </Form.Group>
                </Col>
            </>
            )}

        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th rowSpan={2} className="text-center align-middle" style={{ width: '2.5rem' }}>#</th>
                    <th className="text-center align-middle" rowSpan={2}>Nome</th>
                    <th className="text-center align-middle" rowSpan={2}>CPF/CNPJ/Id. Estrangeiro</th>
                    <th colSpan={2} className="text-center"> Dados do contrato</th>
                </tr>
                <tr>
                    <th className="text-center" >Nro. Contrato</th>
                    <th className="text-center" >Vlr. Contrato Global</th>
                </tr>
            </thead>

            <tbody>
                {listaContratantes?.map((item: ContratanteInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <Link to={''} className="text-danger" onClick={() =>
                                handleOpenModal({ id: item.id, title: item.documento })}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Link>
                        </td>
                        <td className="text-center">{item.xNome}</td>
                        <td className="text-center">{item.documento}</td>
                        <td className="text-center">{item.nroContrato}</td>
                        <td className="text-center">{item.vContratoGlobal?.toLocaleString('pt-BR',
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )}
                        </td>

                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />
        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}